export const parseAdmin = (admin) => {
  const {
    id,
    last_name: lastName,
    first_name: firstName,
    role,
    role_name: roleName,
    email,
    phone,
  } = admin;

  const adminRole = role || roleName;

  return {
    id,
    name: `${firstName} ${lastName}`,
    role: adminRole,
    email,
    phone,
  };
};
